export default __webpack_public_path__ + "static/media/image-zx7.b0fa634f.jpg";